import { render, staticRenderFns } from "./SubmitAnswerConfirmation.vue?vue&type=template&id=5b30bbbd&scoped=true"
import script from "./SubmitAnswerConfirmation.vue?vue&type=script&lang=js"
export * from "./SubmitAnswerConfirmation.vue?vue&type=script&lang=js"
import style0 from "./SubmitAnswerConfirmation.vue?vue&type=style&index=0&id=5b30bbbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b30bbbd",
  null
  
)

export default component.exports